<template>
  <section style="position: relative">
    <div class="d-flex flex-row justify-space-between align-center mb-3">
      <h1 class="section-header__title">
        Согласование общих объемов КЦП на 2025/26 учебный год
      </h1>
      <div class="d-flex flex-row align-start">
        <v-btn
            class="white__v-btn mr-2"
            :loading="downloadingPrintExcel"
            @click="downloadPrint('ExcelStage3AllKcp', downloadingPrintExcel,`Все данные.xlsx`, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',`?idCo=${userId}`)"
        >
          Полный отчет
        </v-btn>
        <v-btn
            v-if="!isBlockedCo"
            class="white__v-btn"
            :loading="blocking"
            @click="blockStage"
        >
          Заблокировать Ввод
        </v-btn>
      </div>
    </div>
    <v-dialog v-model="showMessagesForBlock" scrollable>
      <v-card>
        <v-card-text class="py-10">
          <p class="mb-0" v-for="message in messagesForBlock" :key="message">{{ message }}</p>
        </v-card-text>
      </v-card>
    </v-dialog>
    <wrapper-collapse
        custom-class="orange-border-left"
        title="Правила корректировки общих объемов КЦП на 2025/26 учебный год (далее – ОКЦП) центрам ответственности"
        initial-open>
      <p class=" mb-2 mt-2 ">В целях сохранения баланса распределения контрольных цифр приема на обучение по
        образовательным программам высшего образования, а также по научным специальностям и (или) группам научных
        специальностей для обучения по программам подготовки научных и научно-педагогических кадров в аспирантуре
        (адъюнктуре) допускается корректировка проекта объема контрольных цифр приема в пределах 10 процентов по
        соответствующей НП(С) и (или) УГНС</p>
    </wrapper-collapse>
    <wrapper-collapse
        custom-class="orange-border-left"
        title="Общий объем КЦП для конкурсной группы на 2025/26 гг" initial-open>
      <span style="color: rgb(69, 90, 100); font-size: 14px">Сумма по всем значениям не должна выходить за установленные границы ОКЦП. Контроль осуществляется на этапе блокировки.</span>
      <v-row class="chosen-sum-data" style="margin-top: 5px;">
        <v-col cols="2">
          <div class="subtitle">Очная</div>
          <div v-if="chosenSumData.rfZayavkaValueOchno">
            {{ chosenSumData.rfZayavkaValueOchno }}
            (мин: {{ chosenSumData.zayavkaValueOchno - Math.ceil(chosenSumData.zayavkaValueOchno * 0.1) }},
            макс: {{ chosenSumData.zayavkaValueOchno + Math.ceil(chosenSumData.zayavkaValueOchno * 0.1) }})
          </div>
          <div v-if="chosenSumData.rfZayavkaValueOchno === 0 && !serverSumDataLoading">0</div>
          <v-progress-circular indeterminate color="primary" size="24" v-if="serverSumDataLoading"/>
        </v-col>
        <v-col cols="2">
          <div class="subtitle">Очно-заочная</div>
          <div v-if="chosenSumData.rfZayavkaValueOchnoZaochno">
            {{ chosenSumData.rfZayavkaValueOchnoZaochno }}
            (мин: {{
              chosenSumData.zayavkaValueOchnoZaochno - Math.ceil(chosenSumData.zayavkaValueOchnoZaochno * 0.1)
            }},
            макс: {{
              chosenSumData.zayavkaValueOchnoZaochno + Math.ceil(chosenSumData.zayavkaValueOchnoZaochno * 0.1)
            }})
          </div>
          <div v-if="chosenSumData.rfZayavkaValueOchnoZaochno === 0 && !serverSumDataLoading">0</div>
          <v-progress-circular indeterminate color="primary" size="24" v-if="serverSumDataLoading"/>
        </v-col>
        <v-col cols="2">
          <div class="subtitle">Заочная</div>
          <div v-if="chosenSumData.rfZayavkaValueZaochno">
            {{ chosenSumData.rfZayavkaValueZaochno }}
            (мин: {{ chosenSumData.zayavkaValueZaochno - Math.ceil(chosenSumData.zayavkaValueZaochno * 0.1) }},
            макс: {{ chosenSumData.zayavkaValueZaochno + Math.ceil(chosenSumData.zayavkaValueZaochno * 0.1) }})
          </div>
          <div v-if="chosenSumData.rfZayavkaValueZaochno === 0 && !serverSumDataLoading">0</div>
          <v-progress-circular indeterminate color="primary" size="24" v-if="serverSumDataLoading"/>
        </v-col>
      </v-row>
      <v-row v-if="!serverSumDataLoading && chosenSumData.errors.length > 0">
        <v-col class="py-0">
          <h3>Ошибки:</h3>
          <ul class="pl-6">
            <li class="error--text" style="list-style-type: disc" v-for="(error, key) in chosenSumData.errors"
                :key="key">{{ error }}
            </li>
          </ul>
        </v-col>
      </v-row>
    </wrapper-collapse>
    <v-dialog v-model="showMessagesForBlock" scrollable>
      <v-card>
        <v-card-text class="py-10">
          <p class="mb-0" v-for="message in messagesForBlock" :key="message">&bull; {{ message }}</p>
        </v-card-text>
      </v-card>
    </v-dialog>
    <wrapper-collapse
        v-if="isBlockedCo && !hasConfirmFile"
        title="Просмотр и подписание введенных данных"
        initial-open
        active-class="border-active-content"
    >
      <div class="file">
        <div class="mt-3">
          <v-btn
              class="white__v-btn"
              :loading="downloadingPrint"
              @click="downloadPrint(getPrintType, 'downloadingPrint','Просмотр введенных данных.pdf','application/pdf', `?idCo=${userId}`)"
          >
            Просмотр документа с введенными данными
          </v-btn>
          <div v-if="isValidSystemSetup">
            <v-autocomplete
                v-model="chosenCertificate"
                :items="certificatesList"
                label="Выберите сертификат, которым будет произведена подпись данных"
                no-data-text="Нет доступных сертификатов"
                dense
                class="mt-2"
                clearable
                outlined
            ></v-autocomplete>
            <v-btn class="blue__v-btn" :disabled="!chosenCertificate" :loading="signingFile"
                   @click="signFile(getPrintType, 'downloadingPrint', 'CONFIRMED_FILE_STAGE_THREE', null, `?idCo=${userId}`)">
              Подписать
            </v-btn>
          </div>
          <div v-else>
            <span class="red--text">Не установлен CryptoPro CAdES или плагин работает не правильно.
              Проверить проблемы можно на странице <a
                  href="https://cryptopro.ru/sites/default/files/products/cades/demopage/cades_bes_sample.html">Проверка создания электронной подписи CAdES-BES</a></span>
          </div>
        </div>
      </div>
    </wrapper-collapse>
    <wrapper-collapse
        title="Загружаемые файлы"
        initial-open
        active-class="border-active-content"
        v-if="isBlockedCo"
    >
      <file-container :num-stage="3" :disabled="currentStage !== 3 && !(userId === 6 || userId === 8)"
                      :current-stage="currentStage"
                      :files-config="filesConfig" ref="fileContainerStage3"/>
    </wrapper-collapse>
    <wrapper-collapse
        custom-class="orange-border-left"
        title="Внешняя обработка данных в Excel"
        initial-close>
      <div class="d-flex flex-row align-end">
        <v-btn
            class="white__v-btn" style="margin-right: 30px;"
            @click="getSourceTable2(userId,'Данные из таблицы.xlsx','\'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet\'')"
        >
          Выгрузить данные в Excel
        </v-btn>
        <file-container
            v-if="excelUpload"
            :num-stage="3" :current-stage="3" :cols="12" style="width: 250px"
            :files-config="userId === 8 ? excelMinCultConfig : excelConfig"
            @getAll="reloadServerData"
        />
      </div>
    </wrapper-collapse>
    <wrapper-preview-category>
      <div class="d-flex flex-row align-center justify-space-between">
        <v-menu
            v-if="!loadingSpr"
            v-model="show"
            :close-on-content-click="false"
            :nudge-bottom="40"
            min-width="970px"
            transition="scale-transition"
        >
          <template v-slot:activator="{ on, attrs }">
            <div class="d-flex ugs-name flex-row align-center"
                 v-bind="attrs"
                 v-on="on">
              <p class="mb-0 ">
                {{ selectedUsl.name }} <span>{{ selectedKcp.code }} {{ selectedKcp.name }}</span>
              </p>
              <v-btn class=""
                     icon
              >
                <v-icon color="#0288D1" size="24">
                  mdi-menu-down
                </v-icon>
              </v-btn>
            </div>
          </template>
          <v-card>
            <v-card-text class="d-flex flex-column pa-8">
              <v-row dense justify="center" align="center">
                <v-col class="px-0 usl-name" :class="{'usl-name__chosen': usl.id === 1}"
                       @click="choseUsl({name: 'Бакалавриат', id: 1})">
                  Бакалавриат
                </v-col>
                <v-col class="px-0 usl-name" :class="{'usl-name__chosen': usl.id === 2}"
                       @click="choseUsl({name: 'Специалитет', id: 2})">
                  Специалитет
                </v-col>
                <v-col class="px-0 usl-name" :class="{'usl-name__chosen': usl.id === 3}"
                       @click="choseUsl({name: 'Магистратура', id: 3})">
                  Магистратура
                </v-col>
                <v-col v-if="userId === 9" class="px-0 usl-name" :class="{'usl-name__chosen': usl.id === 6}"
                       @click="choseUsl({name: 'Аспирантура', id: 6})">
                  Аспирантура
                </v-col>
                <v-col v-if="userId === 6" class="px-0 usl-name" :class="{'usl-name__chosen': usl.id === 9}"
                       @click="choseUsl({name: 'Ординатура', id: 9})">
                  Ординатура
                </v-col>
                <v-col v-if="userId === 8" class="px-0 usl-name" :class="{'usl-name__chosen': usl.id === 12}"
                       @click="choseUsl({name: 'Ассистентура', id: 12})">
                  Ассистентура
                </v-col>
                <v-col cols="6">
                  <div class="d-flex flex-row align-start">
                    <v-icon
                        size="20"
                        color="info"
                        class="mt-2 mr-2"
                    >
                      mdi-magnify
                    </v-icon>
                    <v-text-field
                        v-model="search"
                        color="info"
                        outlined
                        label="Начните набирать номер или наименование УГСН"
                        class="search-field"
                        dense
                        style="min-width: 200px"
                    />
                  </div>
                </v-col>
              </v-row>
              <v-divider/>
              <v-row>
                <v-col class="mt-2" style="overflow-y: auto; max-height: 60vh">
                  <ul class="pl-0">
                    <li
                        v-for="item in getKcpGroups"
                        :key="item.id"
                        class="ugs-select"
                        @click="choseKcp(item)">{{ item.code }} - {{ item.name }}
                    </li>
                  </ul>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-menu>
        <div class="filters">
          Формы обучения:
          <span class="mx-2 usl-name" :class="{'usl-name__chosen': fo.id === 1}"
                @click="choseFo({name: 'очно', id: 1})">очно</span>
          <span class="mx-2 usl-name" :class="{'usl-name__chosen': fo.id === 2}"
                @click="choseFo({name: 'очно-заочно', id: 2})">очно-заочно</span>
          <span class="ml-2 usl-name" :class="{'usl-name__chosen': fo.id === 3}"
                @click="choseFo({name: 'заочно', id: 3})">заочно</span>
        </div>
        <div class="d-flex align-center">
          <v-icon size="44" color="warning" class="" style="max-height: 25px!important;">
            mdi-circle-small
          </v-icon>
          <span class="help-text">
            Есть предложения других ЦО
          </span>
          <v-btn class="white__v-btn ml-4"
                 :loading="downloadingPrintExcel"
                 @click="downloadPrint('ExcelStage3', downloadingPrintExcel,`Экспорт данных по ${selectedKcp.code}.xlsx`, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',`?idCo=${userId}`, `&kcpId=${kcp.id}`)"
          >
            Отчет по {{ selectedKcp.code }}
          </v-btn>
        </div>
      </div>
      <v-divider class="my-3"/>
      <!--      <table-cell-co123-menu name-changed-field="pv" id="1"></table-cell-co123-menu>-->
      <GridTable
          :data-rows="showingData"
          :headers="headers.massive"
          :headers-for-rows="headersForRows"
          :loading-data="loadingData"
          :num-cols="headers.countCells"
          :paintBackground="calcBcgr"
          loader-color="#78909C"
      >
        <template #stage3Value="{row}">
          <table-cell-co123-menu
              name-changed-field="stage3Value"
              :id="row.id"
              :row="row"
              :stage-number="3"
              :disabled="disableMainCoColumn(row)"
              :is-main="true"
              :value="row.stage3Value"
              @update="changedValue($event)"
              @getAll="reloadServerData"
          >
            <template #header-title>
              Предложение головного ЦО
            </template>
          </table-cell-co123-menu>
        </template>
        <template #value="{row}">
          <table-cell-co123-menu
              name-changed-field="value"
              :id="row.id"
              :row="row"
              :stage-number="3"
              :disabled="disableCoColumn(row)"
              :is-main="false"
              :value="coRow(row)"
              @update-offer="changedValue($event, true)"
          >
            <template #header-title>
              Предложение ЦО
            </template>
          </table-cell-co123-menu>
        </template>
      </GridTable>
    </wrapper-preview-category>
    <div
        v-if="dialog" :class="dialog ? 'v-overlay--active' : ''" aria-modal="true"
        role="dialog" style="z-index: 2400; margin: 0; align-items: center;
      justify-content: center; border-radius: inherit;display: flex;left: 0;
      pointer-events: none;position: fixed;top: 0;bottom: 0;right: 0; direction: ltr;"
    >
      <div
          @click="dialog = false" style="pointer-events: auto; background: #000000; border-radius: inherit;bottom: 0;
         left: 0;opacity: .32;position: fixed;right: 0;top: 0">
      </div>
      <div style="width: 1160px; max-height: 915px; margin: 24px; display: flex; flex-direction: column;
       outline: none;position: absolute;pointer-events: auto;contain: layout;"
      >
        <v-card
            style="background-attachment: scroll; background-size: auto; display: flex; flex-direction: column; overflow-x: hidden; overflow-y: auto">
          <DialogSvg
              :key="key"
              :columnNum="columnNum"
              :kcpGroupId="kcpGroupId"
              :regionId="regionId"
              :regionName="regionName"
              :sprKcpGroupId="sprKcpGroupId"
              :sprKcpGroupName="sprKcpGroupName"
              :uslName="uslName"
              :foName="foName"
              :pb="pb"
              :row="row"
              style="display: flex"
          />
        </v-card>
      </div>
    </div>
  </section>
</template>

<script>
import WrapperPreviewCategory from "@/components/wrappers/WrapperPreviewCategory";
import GridTable from "@/components/GridTable/GridTable";
import TableCellCo123Menu from "@/components/Menus/tableCellCo123Menu";
import {mapServerData, mapServerSumData} from "@/helpers/coMappers";
import WrapperCollapse from "@/components/wrappers/WrapperCollapse";
import {mapActions, mapGetters} from "vuex";
import stageThree from "@/helpers/tableConfigs/stageThree";
import DialogSvg from "@/components/Dialogs/DialogSvg";
import FileContainer from "@/containers/FileContainer";
import {svgOpenFunctions} from "@/mixins/svgOpenFunctions";
import {setFileFunctions} from "@/mixins/fileFucntions";
import CoStagesController from "@/controllers/OKCP/CoStagesController";
import UserController from "@/controllers/UserController";
import {setCryptoProFunctions} from "@/mixins/cryptoProFunctions";

export default {
  name: "Stage3",
  components: {FileContainer, DialogSvg, WrapperCollapse, TableCellCo123Menu, GridTable, WrapperPreviewCategory},
  mixins: [svgOpenFunctions, setFileFunctions, setCryptoProFunctions],
  data() {
    return {
      kcp: null,
      usl: {name: 'Бакалавриат', id: 1},
      fo: {name: 'Очно', id: 1},
      show: false,
      blocking: false,
      messagesForBlock: [],
      showMessagesForBlock: false,
      dialog: false,
      pb: false,
      excelUpload: true,
      filesConfig: [
        {
          name: 'Файл подтверждения введенных данных',
          types: ['application/pdf'],
          typesForChose: ['application/pdf'],
          id: null,
          fileType: 'CONFIRMED_FILE_STAGE_THREE',
          canUpload: false
        },
        // {
        //   name: 'Расчетный файл',
        //   types: ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
        //   typesForChose: ['.xlsx', '.xls'],
        //   id: null,
        //   fileType: 'CALCULATED_FILE_STAGE_THREE'
        // },
        {
          name: 'Пояснительная записка',
          types: ['application/pdf'],
          typesForChose: ['application/pdf'],
          id: null,
          fileType: 'EXPLANATORY_FILE_STAGE_THREE',
          canUpload: true
        },
        {
          name: 'Письмо для Минобрнауки',
          types: ['application/pdf'],
          typesForChose: ['application/pdf'],
          id: null,
          fileType: 'LETTER_FILE_STAGE_THREE',
          canUpload: true
        },
      ],
      excelConfig: [
        {
          name: '',
          types: ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
          typesForChose: ['.xlsx', '.xls'],
          id: null,
          fileType: 'EXCEL_FOUNDER_FILE',
          canUpload: true
        },
      ],
      excelMinCultConfig: [
        {
          name: 'Файл Excel',
          types: ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
          typesForChose: ['.xlsx', '.xls'],
          id: null,
          fileType: 'EXCEL_MINKULT',
          canUpload: true
        }
      ],
      columnNum: null,
      kcpGroupId: null,
      row: null,
      search: '',
      districts: [],
      serverData: [],
      loadingData: false,
      headers: {
        massive: [],
        headersForRows: [],
        countCells: 1
      },
      serverSumData: [],
      serverSumDataLoading: false,
      chosenSumData: {
        zayavkaValueOchnoZaochno: null,
        zayavkaValueOchno: null,
        zayavkaValueZaochno: null,
        rfZayavkaValueOchnoZaochno: null,
        rfZayavkaValueOchno: null,
        rfZayavkaValueZaochno: null,
        errors: []
      },
      chosenData: []
    }
  },
  computed: {
    ...mapGetters('spr', {getKcpGroupsDefault: 'getKcpGroups', getKcpGroupsStatus: 'getKcpGroupsStatus'}),
    ...mapGetters('checkFilled', {
      getBlockStageThree: 'getBlockStageThree',
      currentStage: 'currentStage',
      getBlockInfo: "getBlockInfo",
      getFilesList: 'getFilesList',
      getFilesListStatus: 'getFilesListStatus'
    }),
    ...mapGetters('keycloak', {getFakeUser: 'getFakeUser', userId: 'userId'}),
    getPrintType() {
      return "PrintStage3"
    },
    isBlockedCo() {
      if (this.currentStage < 3) {
        if (this.userId === 6) {
          if (this.usl.id === 9) return this.getBlockInfo?.find(el => el.stageId === 3)?.block
          return true;
        }
        if ((this.userId === 8 || this.getFakeUser?.id === 6 || this.getFakeUser?.id === 8)) {
          return this.getBlockInfo?.find(el => el.stageId === 3)?.block
        }
        return true
      }
      return this.getBlockStageThree
    },
    hasConfirmFile() {
      const cffile = this.getFilesList.filter(item => item.fileType === 'CONFIRMED_FILE_STAGE_THREE')[0];
      return cffile !== undefined && cffile !== null && !!cffile.id;
    },
    selectedKcp() {
      return this.kcp ?? {id: null, name: 'Выберите направление'}
    },
    getKcpGroups() {
      let array
      if (this.getFakeUser?.id === 9 || this.getAuthData?.founderID === 9) {
        array = this.getKcpGroupsDefault.filter(el => ![51, 54].includes(el.ugs.id)
            || [51, 54].includes(el.ugs.id) && ['51.03.01', '51.04.01', '54.03.01', '54.04.01'].includes(el.code));
      } else {
        array = this.getKcpGroupsDefault;
      }
      return array.filter(el => el.usl?.id === this.usl?.id
          && (!this.search || el.code.toLowerCase().search(this.search.toLowerCase()) !== -1
              || el.name.toLowerCase().search(this.search.toLowerCase()) !== -1))
    },
    loadingSpr() {
      return this.getKcpGroupsStatus
    },
    selectedUsl() {
      return this.usl
    },
    kcpGroupIsMain() {
      return this.kcp?.isMain ?? false
    },
    headersForRows() {
      return this.headers.rowsMassive
    },
    showingData() {
      return this.chosenData?.data ?? []
    },
  },

  watch: {
    getKcpGroupsStatus(newValue) {
      this.initFirstEntryKcp(newValue)
    },
    'getKcpGroupsDefault.length'() {
      if (!this.loadingData)
        this.initFirstEntryKcp()
    },
  },

  created() {
    this.headers = stageThree.call(this);
    this.getServerData();
    this.initFirstEntryKcp();
    if (this.isBlockedCo) {
      this.checkSystem()
    }
  },

  methods: {
    ...mapActions('checkFilled', {changeBlockInfo: 'changeBlockInfo', getBlockAllows: 'getBlockAllows'}),
    ...mapActions('notifications', {addNotification: 'addNotification'}),
    initFirstEntryKcp(value = this.getKcpGroupsStatus) {
      if (!value && (!this.kcp || this.getFakeUser) && !this.loadingData) {
        if (this.getAuthData?.founderID === 8 || this.getFakeUser?.founderID === 8) {
          this.kcp = this.getKcpGroups.find(el => el.code === "51.03.02");
          this.usl = this.kcp.usl
        } else {
          this.kcp = this.getKcpGroupsDefault.find(el => el);
        }

        this.getServerData();
        this.getSumData();
      }
    },

    initFiles() {
      console.log(this.$refs.fileContainerStage3)
      this.$refs.fileContainerStage3.initFiles()
    },

    async blockStage() {
      try {
        this.blocking = true
        const messagesBlock = await UserController.getBlockAllowInfo()
        if (messagesBlock?.messageStage3.length === 0) {
          const res = await UserController.setBlock('founder', 3)
          await this.changeBlockInfo(res);
          this.checkSystem()
        } else {
          this.messagesForBlock = messagesBlock?.messageStage3;
          this.showMessagesForBlock = true;
        }
        this.blocking = false
      } catch (e) {
        this.blocking = false
      }
    },

    calcBcgr() {
      return (r) => {
        if (r && !r.regionId && !r.districtId) {
          const delta = this.showingData[0].stage1Value - this.showingData[0].stage3Value;
          const sign = (delta) > 0 ? 1 : delta === 0 ? 0 : -1;
          switch (sign) {
            case 0:
              return 'success-class-background';
            case 1:
              return 'error-class-background';
            case -1:
              return 'warning-class-background';
          }
        }
      }
    },

    changedValue(e, isOffer = false) {
      const searchDownloadedElement = this.returnDownloadedElement();
      // console.log(searchDownloadedElement);
      if (searchDownloadedElement) {
        const searchedRowIndex = searchDownloadedElement.data.findIndex(el => el.id === e.row?.id);
        const searchedRow = searchDownloadedElement.data[searchedRowIndex];
        // console.log(searchedRow);
        if (searchedRow) {
          if (!isOffer) {
            const oldValue = Number.isNaN(Number(searchedRow[e.dataField])) ? 0 : searchedRow[e.dataField];
            searchedRow[e.dataField] = e.value;
            const delta = Math.abs(oldValue - e.value);
            const sign = (e.value - oldValue) >= 0 ? 1 : -1;
            let i = searchedRowIndex;
            i--;
            while (i) {
              if (searchDownloadedElement.data[i].districtId) {
                const districtRow = searchDownloadedElement.data[i];
                districtRow[e.dataField] = Number.isNaN(Number(districtRow[e.dataField])) ? 0 : districtRow[e.dataField];
                if (sign === -1) {
                  districtRow[e.dataField] -= delta;
                } else if (sign === 1) {
                  districtRow[e.dataField] += delta;
                }
                i = 0;
              } else
                i--;
            }
          } else {
            if (!searchedRow.stageDataOffers)
              searchedRow.stageDataOffers = [];
            const offerIndex = searchedRow.stageDataOffers.findIndex(el => el.id === e.offer.id);
            if (offerIndex === -1)
              searchedRow.stageDataOffers.push(e.offer);
            else
              searchedRow.stageDataOffers.splice(offerIndex, 1, e.offer);
            const oldValue = Number.isNaN(Number(searchedRow.stag31OfferValue)) ? 0 : searchedRow.stage3OfferValue;
            const delta = Math.abs(oldValue - e.offer.value);
            const sign = (e.offer.value - oldValue) >= 0 ? 1 : -1;
            const result = sign * delta;
            let i = searchedRowIndex;
            i--;
            while (i) {
              if (searchDownloadedElement.data[i].districtId) {
                const districtRow = searchDownloadedElement.data[i];
                districtRow.stage3OfferValue = Number.isNaN(Number(districtRow.stage3OfferValue)) ? 0 : districtRow.stage3OfferValue;
                districtRow.stage3OfferValue += (result);
                i = 0;
              } else
                i--;
            }
            searchedRow.stage3OfferValue = e.offer.value;
          }
        }
        const searchedChosenRowIndex = this.chosenData.data.findIndex(el => el.id === e.row?.id);
        const searchedChosenData = this.chosenData.data[searchedChosenRowIndex];
        if (searchedChosenData) {
          if (!isOffer) {
            const oldValue = Number.isNaN(Number(searchedChosenData[e.dataField])) ? 0 : searchedChosenData[e.dataField];
            searchedChosenData[e.dataField] = e.value;
            const delta = Math.abs(oldValue - e.value);
            const sign = (e.value - oldValue) >= 0 ? 1 : -1;
            let i = searchedChosenRowIndex;
            i--;
            while (i !== 0) {
              if (searchDownloadedElement.data[i].districtId) {
                const districtRow = searchDownloadedElement.data[i];
                districtRow[e.dataField] = Number.isNaN(Number(districtRow[e.dataField])) ? 0 : districtRow[e.dataField];
                if (sign === -1) {
                  districtRow[e.dataField] -= delta;
                } else if (sign === 1) {
                  districtRow[e.dataField] += delta;
                }
                i = 0;
              } else
                i--;
            }
          } else {
            if (!searchedChosenData.stageDataOffers)
              searchedChosenData.stageDataOffers = [];
            const offerIndex = searchedChosenData.stageDataOffers.findIndex(el => el.id === e.offer.id);
            if (offerIndex === -1)
              searchedChosenData.stageDataOffers.push(e.offer);
            else
              searchedChosenData.stageDataOffers.splice(offerIndex, 1, e.offer);
            const oldValue = Number.isNaN(Number(searchedChosenData.stage3OfferValue)) ? 0 : searchedChosenData.stage3OfferValue;
            const delta = Math.abs(oldValue - e.offer.value);
            const sign = (e.offer.value - oldValue) >= 0 ? 1 : -1;
            const result = sign * delta;
            let i = searchedChosenRowIndex;
            i--;
            while (i) {
              if (this.chosenData.data[i].districtId) {
                const districtRow = this.chosenData.data[i];
                districtRow.stage3OfferValue = Number.isNaN(Number(districtRow.stage3OfferValue)) ? 0 : districtRow.stage3OfferValue;
                districtRow.stage3OfferValue += (result);
                i = 0;
              } else
                i--;
            }
            searchedChosenData.stage3OfferValue = e.offer.value;
          }
        }
      }
    },

    async reloadServerData(arg = 0) {
      this.serverData = [];
      const finalData = [];
      if (!this.kcp?.id || !this.fo?.id) {
        this.loadingData = false;
        return;
      }
      const districts = await CoStagesController.getDataStage(this.kcp.id, this.fo.id);
      this.districts = districts;
      districts.forEach(el => {
        const {regions, ...district} = el;
        if (Array.isArray(regions))
          finalData.push({...district, regionName: district.districtName, id: Math.random()}, ...regions);
        else
          finalData.push({...district, regionName: district.districtName, id: Math.random()});
      })
      const firstElement = finalData.length > 0 ? finalData[2] : null;
      this.serverData.push(mapServerData(firstElement, finalData, this.$data));
      this.chosenData = this.returnDownloadedElement();
      if (arg === 1) {
        // this.excelUpload = false // скрытие кнопки загрузки экселя по передаче нужного аргумента эмитом
        await this.addNotification({
          notificationStatus: 'success',
          notificationMessage: 'Файл загружен, данные таблицы обновлены',
          timeout: 3000
        })
      }
    },

    async getServerData() {
      try {
        this.loadingData = true;
        const searchDownloadedElement = this.returnDownloadedElement()
        if (searchDownloadedElement) {
          this.chosenData = searchDownloadedElement;
        } else {
          const finalData = [];
          if (!this.kcp?.id || !this.fo?.id) {
            this.loadingData = false;
            return;
          }
          const districts = await CoStagesController.getDataStage(this.kcp.id, this.fo.id);
          this.districts = districts;
          districts.forEach(el => {
            const {regions, ...district} = el;
            if (Array.isArray(regions))
              finalData.push({...district, regionName: district.districtName, id: Math.random()}, ...regions);
            else
              finalData.push({...district, regionName: district.districtName, id: Math.random()});
          })
          const firstElement = finalData.length > 0 ? finalData[2] : null;
          this.serverData.push(mapServerData(firstElement, finalData, this.$data));
          this.chosenData = this.returnDownloadedElement();
        }
        this.loadingData = false;
      } catch (e) {
        console.error('getServerData ', e);
        this.serverData.push(mapServerData(null, [], this.$data));
        this.chosenData = this.returnDownloadedElement();
        this.loadingData = false;
      }
    },

    getSumData() {
      const searchDownloadedElement = this.returnDownloadedSumsElement()
      if (searchDownloadedElement) {
        this.chosenSumData = searchDownloadedElement.data;
        return;
      }
      this.serverSumDataLoading = true;
      if (this.selectedKcp.id) {
        CoStagesController.getDataStageThreeSumsForKcp(this.selectedKcp.id)
            .then(data => {
              this.serverSumData.push(mapServerSumData(data, this.$data));
              this.chosenSumData = this.returnDownloadedSumsElement()?.data;
            })
            .finally(() => this.serverSumDataLoading = false)
      }
    },

    returnDownloadedElement() {
      return this.serverData.find(el => el.uslId === this.usl.id && el.foId === this.fo.id && el.kcpId === this.kcp.id);
    },

    returnDownloadedSumsElement() {
      return this.serverSumData.find(el => el.kcpId === this.kcp.id);
    },

    choseKcp(kcp) {
      this.kcp = kcp;
      this.show = false;
      this.getServerData();
      this.getSumData();
    },

    choseUsl(usl) {
      this.usl = usl;
      this.getServerData()
    },

    choseFo(fo) {
      this.fo = fo;
      this.getServerData()
    },

    disableMainCoColumn(row) {
      if ((this.getFakeUser?.id === 8 || this.getAuthData?.founderID === 8) &&
          (['51.03.01', '51.04.01', '54.03.01', '54.04.01'].includes(this.kcp?.code)) && !row?.districtId) {
        return false
      } else return !!(!this.kcpGroupIsMain || !row.regionId || this.isBlockedCo);
    },

    disableCoColumn(row) {
      if ((this.getFakeUser?.id === 9 || this.getAuthData?.founderID === 9) &&
          (['51.03.01', '51.04.01', '54.03.01', '54.04.01'].includes(this.kcp?.code)) && !row?.districtId) {
        return false
      } else return !!(this.kcpGroupIsMain || !row.regionId || this.isBlockedCo);
    },

    coRow(row) {
      if (row?.stage3OfferValue === null && row?.regionId !== null) {
        return row.startValueStage3
      } else if (row?.regionId === null) { // вывод суммы округа
        return this.notMainCoSum(row.districtId)
      } else if (row.stage3OfferValue >= 0) {
        return row?.stage3OfferValue
      }
    },

    notMainCoSum(districtId) {
      const array = this.districts?.find(el => el.districtId === districtId)?.regions;
      if (array) {
        const arrayFormatted = array.map((el) => {
          if (el.stage3OfferValue === null) {
            return el.startValueStage3
          } else if (el.stage3OfferValue >= 0) {
            return el.stage3OfferValue
          }
        })
        return arrayFormatted?.reduce((partialSum, a) => partialSum + a, 0);
      }
      return 0
    }
  },
}
</script>

<style lang="sass" scoped>
</style>